// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"3702f5aa","483":"73ad749b"}[chunkId] + ".chunk.js";
};